import React, { useState } from "react";
import { CategoryTitle, Title, SubTitle, Label } from "./TitleStyle";

function autoTab(obj) {
  var pattern = new String("_-____-_____-__-_"); // กำหนดรูปแบบในนี้
  var pattern_ex = new String("-"); // กำหนดสัญลักษณ์หรือเครื่องหมายที่ใช้แบ่งในนี้
  var returnText = new String("");
  var obj_l = obj.length;
  var obj_l2 = obj_l - 1;
  for (var i = 0; i < pattern.length; i++) {
    if (obj_l2 == i && pattern.charAt(i + 1) == pattern_ex) {
      returnText += obj + pattern_ex;
      obj = returnText;
    }
  }
  if (obj_l >= pattern.length) {
    obj = obj.substr(0, pattern.length);
  }
  return obj;
}

const CelesTextFieldWithTitle = ({
  label,
  name,
  setField,
  value,
  setFieldMulti,
  primaryField,
  index,
  className = "text-lg mb-2 text-gray-600 ",
}) => {
  const onChange = (e) => {
    if (name === "citizen_number") {
      const value = autoTab(e.target.value);
      return setFieldMulti(name, primaryField, index)(value);
    }

    if (primaryField) {
      return setFieldMulti(name, primaryField, index)(e.target.value);
    }
    setField(name)(e.target.value);
  };

  return (
    <div className="w-full">
      <div className={className}>{label}</div>
      <input
        type=""
        name={name}
        placeholder=""
        value={value}
        onChange={onChange}
        className={
          "bg-white border border-gray-200 my-1 rounded p-1 px-2 w-full focus:ring-1 focus:ring-green-500 outline-none  text-gray-700 "
        }
      />
    </div>
  );
};

export default CelesTextFieldWithTitle;
